import warnings from "./warnings/warnings";
import "../../../maps-frontend/assets/css/plugins/warnings/warnings.scss";


export default warnings;
export {plugincode} from "./warnings/warnings";
